// src/modules/PreOperations/Preview.jsx
import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Form,
  Input,
  Radio,
  Spin,
  message,
  Typography,
  Divider,
  Empty,
  InputNumber,
} from "antd";

const { Text } = Typography;
const { TextArea } = Input;
const API_URL = process.env.REACT_APP_API_URL;

const Preview = ({ refreshKey, onDataLoaded }) => {
  const [questions, setQuestions] = useState(null);
  const [loading, setLoading] = useState(true);

  // Usar useRef para evitar bucles infinitos con onDataLoaded
  const onDataLoadedRef = useRef(onDataLoaded);

  useEffect(() => {
    onDataLoadedRef.current = onDataLoaded;
  }, [onDataLoaded]);

  const fetchQuestions = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");

      const res = await fetch(`${API_URL}/pre-operaciones`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || res.statusText);
      }
      const data = await res.json();
      if (!Array.isArray(data)) {
        throw new Error("La respuesta no es un array");
      }

      const sortedData = [...data].sort((a, b) => a.orden - b.orden);
      setQuestions(sortedData);

      if (onDataLoadedRef.current) {
        onDataLoadedRef.current(sortedData);
      }
    } catch (err) {
      message.error("No se pudo cargar la vista previa");
      console.error("Error al cargar la vista previa:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchQuestions();
  }, [refreshKey, fetchQuestions]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "30px 0" }}>
        <Spin>
          <div style={{ padding: "30px", textAlign: "center" }}>
            <p>Cargando vista previa...</p>
          </div>
        </Spin>
      </div>
    );
  }

  if (!questions || questions.length === 0) {
    return (
      <Empty
        description="No hay preguntas configuradas"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <div style={{ maxHeight: "65vh", overflowY: "auto", padding: "0 10px" }}>
      <Form layout="vertical">
        {questions.map((q, index) => (
          <Form.Item
            key={q.id}
            label={
              <Text strong>
                {index + 1}. {q.titulo}
              </Text>
            }
          >
            {q.tipoRespuesta === "texto" && (
              <TextArea rows={2} placeholder="(Campo de texto)" disabled />
            )}
            {q.tipoRespuesta === "numerico" && (
              <InputNumber
                placeholder="(Campo numérico)"
                disabled
                style={{ width: "100%" }}
              />
            )}
            {q.tipoRespuesta === "checklist_simple" &&
              Array.isArray(q.opciones) &&
              q.opciones.length > 0 && (
                <Radio.Group disabled>
                  {q.opciones.map((opt, i) => (
                    <Radio key={i} value={opt}>
                      {opt}
                    </Radio>
                  ))}
                </Radio.Group>
              )}
            {q.tipoRespuesta === "checklist_multiple" &&
              Array.isArray(q.descripciones) && (
                <div style={{ marginBottom: 16 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left", padding: 8 }}>Ítem</th>
                        {q.descripciones[0]?.options?.map((opt) => (
                          <th
                            key={opt}
                            style={{ padding: 8, textAlign: "center" }}
                          >
                            {opt}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {q.descripciones.map((grp, gi) => (
                        <tr key={gi}>
                          <td style={{ padding: 8 }}>{grp.label}</td>
                          {grp.options.map((opt) => (
                            <td key={opt} style={{ textAlign: "center" }}>
                              <Radio checked={false} disabled />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

            <Divider />
          </Form.Item>
        ))}
      </Form>
    </div>
  );
};

export default Preview;
